<template>
  <div class="test__info">
    <div class="row test">
      <div :class="colClass">
        <div class="test__info-item p-24">
          <img src="/pic/profile/icon-test-time.svg" />
          <div class="mt-24">
            {{ test.duration }} {{ test.duration | pluralize('ru', ['минута', 'минуты', 'минут']) }}
          </div>
        </div>
        <div class="test__info-item-desc">
          На тест отведено ограниченное количество времени
        </div>
      </div>
      <div :class="colClass">
        <div class="test__info-item p-24">
          <img src="/pic/profile/icon-test-count.svg" />
          <div class="mt-24">
            Вопросов: {{ questionsCount }}
          </div>
        </div>
        <div class="test__info-item-desc">
          Вопросы, на которые вы не успеете ответить, будут засчитаны как неправильные
        </div>
      </div>
      <div :class="colClass">
        <div class="test__info-item p-24">
          <img src="/pic/profile/icon-test-retry.svg" />
          <div v-if="hasPassPercent" class="mt-24">
            Попыток: {{ maxAttempts }}
          </div>
          <div v-else class="mt-24">
            Пересдач: {{ test.retakes ? test.retakes : 'нет' }}
          </div>
        </div>
        <div v-if="hasPassPercent" class="test__info-item-desc">
          После зачёта пересдача недоступна. Внимательно проверьте свои ответы перед отправкой результатов
        </div>
        <div v-else class="test__info-item-desc">
          Внимательно проверьте свои ответы перед отправкой результатов
        </div>
      </div>
      <div v-if="hasPassPercent" :class="colClass">
        <div class="test__info-item p-24">
          <img src="/pic/profile/icon-test-passed.svg" />
          <div class="mt-24">
            Порог зачёта: {{ test.pass_percent }}%
          </div>
        </div>
        <div v-if="passCount" class="test__info-item-desc">
          Для зачёта нужно правильно ответить не менее чем на {{ passCount }} из {{ questionsCount }} {{ questionsCount | pluralize('ru', ['вопроса', 'вопросов', 'вопросов']) }}
        </div>
        <div v-else class="test__info-item-desc">
          Для зачёта нужно правильно ответить не менее чем на {{ test.pass_percent }}% вопросов
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestStartInfo",
  props: {
    test: {
      type: Object,
      required: true
    }
  },
  computed: {
    questionsCount() {
      return this.test.questions_count ? this.test.questions_count : (this.test.questionsCount ? this.test.questionsCount : 0);
    },
    hasPassPercent() {
      // Порог зачёта задан (итоговый тест HITECH). Без порога показываем прежние три плашки
      return this.test.pass_percent !== null && this.test.pass_percent !== undefined;
    },
    colClass() {
      return this.hasPassPercent ? 'col-lg-3 col-md-6 col-sm-6' : 'col-md-4 col-sm-4';
    },
    maxAttempts() {
      return this.test.max_attempts ? this.test.max_attempts : (Number(this.test.retakes) || 0) + 1;
    },
    passCount() {
      // Минимум верных ответов для зачёта, как на бэкенде: верных * 100 >= порог * вопросов (85% от 75 — 64)
      return this.questionsCount ? Math.ceil(this.test.pass_percent * this.questionsCount / 100) : 0;
    }
  }
}
</script>

<style scoped>

</style>
